<template>
  <v-container fluid class="down-top-padding">
    <BaseBreadcrumb :title="page.title" :icon="page.icon" :breadcrumbs="breadcrumbs"></BaseBreadcrumb>
    <v-row>
      <v-col cols="12" sm="12">
        <BaseCard heading="Listado de Programación de Menú">
          <GestionProgramacionMenuLista @open="open" @close="close"></GestionProgramacionMenuLista>
        </BaseCard>
      </v-col>
    </v-row>
    <div v-if="showLoading" class="progress-background">
      <v-progress-circular :size="70" :width="7" color="primary" indeterminate></v-progress-circular>
    </div>
  </v-container>
</template>

<script>
export default {
  name: 'GestionProgramacion',
  components: {
    GestionProgramacionMenuLista: () => import('../components/GestionProgramacionMenuLista')
  },
  data: () => ({
    showLoading: false,
    page: {
      title: 'Comedor'
    },
    breadcrumbs: [
      {
        text: 'Gestión de Programación de Menú',
        disabled: true
      },
      {
        text: 'Lista de Programación de Menú',
        disabled: true
      }
    ]
  }),
  methods: {
    open() {
      this.showLoading = true;
    },
    close() {
      this.showLoading = false;
    }
  }
};
</script>
